(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["finance-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
  function formatMoney(value) {
    if (!isFinite(value)) return '$0.00';
    return '$' + value.toFixed(2);
  }

  function calculate(root) {
    var price = parseFloat(root.querySelector('[data-finance-price]').value) || 0;
    var rate = parseFloat(root.querySelector('[data-finance-rate]').value) || 0;
    var period = parseFloat(root.querySelector('[data-finance-period]').value) || 0;
    var downPayment = parseFloat(root.querySelector('[data-finance-down-payment]').value) || 0;

    var principal = Math.max(price - downPayment, 0);
    var monthlyRate = (rate / 100) / 12;
    var n = period;

    var monthlyPayment = 0;
    if (n > 0) {
      if (monthlyRate === 0) {
        monthlyPayment = principal / n;
      } else {
        var factor = Math.pow(1 + monthlyRate, n);
        monthlyPayment = (principal * monthlyRate * factor) / (factor - 1);
      }
    }

    var totalAmount = monthlyPayment * n;
    var totalInterest = totalAmount - principal;

    root.querySelector('[data-finance-monthly]').textContent = formatMoney(monthlyPayment);
    root.querySelector('[data-finance-total-interest]').textContent = formatMoney(totalInterest);
    root.querySelector('[data-finance-total-amount]').textContent = formatMoney(totalAmount);
  }

  document.querySelectorAll('[data-finance-calculator]').forEach(function (root) {
    calculate(root);
    var button = root.querySelector('[data-finance-calculate]');
    button.addEventListener('click', function () {
      calculate(root);
    });
    root.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') calculate(root);
      });
    });    
  });

  $('.finance-calculator__btn').on('click', function() {
    $('.finance-calculator__result').slideDown();
  });

})();
  } catch(e) { console.error(e); }
})();

})();
